import alegartaTile from '../images/alegarta-tile.png';

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const densityFor = (message) => {
  const length = String(message || '').length;
  if (length > 420) return 'compact';
  if (length > 240) return 'medium';
  return 'standard';
};

export function buildGiftCardPrintHtml(cards, options = {}) {
  const smokeBackgroundUrl = options.smokeBackgroundUrl || alegartaTile;
  const rotateForTray = options.rotateForTray === true;
  const list = Array.isArray(cards) ? cards.filter((card) => card?.message?.trim()) : [];
  const pages = list
    .map(
      (card) => `
<article class="gift-card gift-card--${densityFor(card.message)}${
        rotateForTray ? ' gift-card--tray-flip' : ''
      }" data-gift-card="${escapeHtml(card.orderKey)}">
  <div class="gift-card__smoke" aria-hidden="true"></div>
  <div class="gift-card__message">${escapeHtml(card.message)}</div>
  <div class="gift-card__order">#${escapeHtml(card.orderKey)}</div>
</article>`,
    )
    .join('\n');

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8">
<title>Gift inscription cards - London Smoke &amp; Cure</title>
<style>
@page { size: A6 landscape; margin: 0; }
html, body { margin: 0; padding: 0; background: #fff; }
* { box-sizing: border-box; }
.gift-card {
  position: relative;
  width: 148mm;
  height: 105mm;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 13mm;
  page-break-after: always;
  break-after: page;
  background: #fff;
  color: #252b2a;
  font-family: 'Johnston ITC W01 Light', 'Montserrat', Arial, sans-serif;
  font-weight: 300;
  text-align: center;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.gift-card--tray-flip {
  transform: rotate(180deg);
  transform-origin: center center;
}
.gift-card:last-child { page-break-after: auto; break-after: auto; }
.gift-card__smoke {
  position: absolute;
  inset: 0;
  background-color: #fff;
  background-image: url("${escapeHtml(smokeBackgroundUrl)}");
  background-repeat: repeat;
  background-size: 62mm 62mm;
}
.gift-card__message {
  position: relative;
  z-index: 1;
  max-width: 120mm;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 14.5pt;
  line-height: 1.32;
  font-weight: 300;
}
.gift-card--medium .gift-card__message { font-size: 12pt; }
.gift-card--compact .gift-card__message { font-size: 9.5pt; line-height: 1.25; }
.gift-card__order {
  position: absolute;
  z-index: 1;
  bottom: 8mm;
  left: 0;
  right: 0;
  color: #707876;
  font-size: 8.5pt;
  font-weight: 300;
}
</style>
</head>
<body>${pages}</body>
</html>`;
}

export default buildGiftCardPrintHtml;
